import React from 'react';
import { NextPage } from 'next';
import Layout from '../../../components/layout';
import SidebarContainer from '../../../components/@container/sidebar-container';
import VidaSidebar from '../../../components/@vida/vida-sidebar';
import VidaPurchase from '../../../components/@vida/vida-purchase';

const VidaPurchasePage: NextPage = () => (
  <Layout title="VIDA Purchasing" omit={true}>
    <SidebarContainer sidebar={<VidaSidebar />} content={<VidaPurchase />} />
  </Layout>
);

export default VidaPurchasePage;
